exports = module.exports = require("../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".order-common-details{text-align:left;border-bottom:1px solid rgba(0,0,0,.075)}.order-common-details .taxes{font-size:.85rem}.order-common-details__title{font-weight:300;font-size:1.25rem}.order-common-details__section .title{font-weight:300;font-size:1.25rem;font-size:1rem}.order-common-details__section .benefits,.order-common-details__section .item{font-size:.85rem}body[dir=rtl] .order-common-details {\n  text-align: right;\n}\n", ""]);

// exports
